$(function () {
	var $input = $('.form__group .form__input');

	$input.focus(function(){
		$(this).parent('.form__group').addClass("form__group--focus");
		$(this).parent('.form__group').removeClass('form__group--error');
	});

	$input.blur(function(){
		if ( $(this).val() === ''){
			$(this).parent('.form__group').removeClass("form__group--focus");
		}
	});

	$('.form__input-file').on('change', function(e){
		var file = this.files[0];
		$('.form__file-title').html(file ? file.name : 'Прикрепить резюме');
		if(file && $(this).parent('.js-group').hasClass('form__group--error')) {
			$(this).parent('.js-group').removeClass('form__group--error');
		}
	});

	var hash = window.location.hash;
	if (hash == '#contact_form') {
		$('#contact_form').find('input:not([type="hidden"])').first().focus();
	}
});

//Согласие на обработку информации

$(function () {
	$('.js-agreement').change(function() {
		let $this = $(this);
		let btn = $this.closest('.js-form').find('.btn');
		if ($this.is(':checked')) {
			btn.removeAttr("disabled");
		} else {
			btn.attr("disabled", true);
		}
	});
});
